// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"b3f135d8","122":"5b2f2c97","387":"48be390c","842":"cebc2309"}[chunkId] + ".chunk.css";
};